<span [innerHtml]="output | safeHtml" [attr.data-automation-id]="id"></span>
